export default class PerformanceModel {
    constructor(data) {
      this.userId = data.userId;
      this.data = data.data;
      this.kind = data.kind;
    }
  }